module.exports = __webpack_public_path__ + "VIPH7.png?018bb457aee26cc7051940ae1207e994";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH7.png
// module id = 100
// module chunks = 0